import { render, staticRenderFns } from "./billTabs.vue?vue&type=template&id=06313c2e&scoped=true"
import script from "./billTabs.vue?vue&type=script&lang=js"
export * from "./billTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06313c2e",
  null
  
)

export default component.exports